<template>
  <SingleSelect
    v-model="adaptedValue"
    :searchable="false"
    :items="selectItems"
    :label="$t('components.filters.CheckedPosts.label')"
    :placeholder="$t('components.filters.CheckedPosts.placeholder')"
  >
    <template v-slot:selection="{item}">
      <span
        class="filter__summary text--disabled"
      >
        {{ item.text }}
      </span>
    </template>
  </SingleSelect>
</template>

<script>
import SingleSelect from './models/SingleSelect';

export default {
  name: 'CheckedPosts',
  components: {
    SingleSelect,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    selectItems() {
      return [
        {
          text: this.$t('components.filters.CheckedPosts.items.all'),
          value: null,
        },
        {
          text: this.$t('components.filters.CheckedPosts.items.onlyChecked'),
          value: true,
        },
        {
          text: this.$t('components.filters.CheckedPosts.items.onlyUnchecked'),
          value: false,
        },
      ];
    },
    adaptedValue: {
      get() {
        return this.value?.value;
      },
      set(newValue) {
        let value;

        if (newValue !== null) {
          value = {
            value: newValue,
          };
        }

        this.$emit('input', value);
      },
    },
  },
};

</script>

<style scoped lang="scss">
  .v-select__selection.v-select__selection--comma {
    line-height: 120%;
  }

  .filter__summary {
    font-size: 13.333px;
  }
</style>
